import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import { captureLeadSource, getStoredLeadSource } from './utils/leadSource';
import Home from './pages/Home.js';
import { useAuth } from './contexts/AuthContext';
const Sidebar = lazy(() => import('./components/Sidebar.js'));
const Topbar = lazy(() => import('./components/Topbar.js'));
const ActionPermissionStyles = lazy(() => import('./components/ActionPermissionStyles.js'));
const StudentHelpChat = lazy(() => import('./components/StudentHelpChat.js'));
const Courses = lazy(() => import('./pages/Courses.js'));
const CoursesGatePage = lazy(() => import('./pages/CoursesGatePage.js'));
const CourseDetails = lazy(() => import('./pages/CourseDetails.js'));
const SharedCoursesPage = lazy(() => import('./pages/SharedCoursesPage.js'));
const Login = lazy(() => import('./pages/Login.js'));
const Register = lazy(() => import('./pages/Register.js'));
// Study destination pages
const StudyInCanada = lazy(() => import('./pages/StudyInCanada.js'));
const StudyInUAE = lazy(() => import('./pages/StudyInUAE.js'));
const StudyInAustralia = lazy(() => import('./pages/StudyInAustralia.js'));
const StudyInNewZealand = lazy(() => import('./pages/StudyInNewZealand.js'));
const StudyInUK = lazy(() => import('./pages/StudyInUK.js'));
const StudyInUSA = lazy(() => import('./pages/StudyInUSA.js'));
const AboutUs = lazy(() => import('./pages/AboutUs.js'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy.js'));
const Disclaimer = lazy(() => import('./pages/Disclaimer.js'));
const FAQs = lazy(() => import('./pages/FAQs.js'));
const TermsConditions = lazy(() => import('./pages/TermsConditions.js'));
const Coaching = lazy(() => import('./pages/Coaching.js'));
const CoachingDemoClassPage = lazy(() => import('./pages/CoachingDemoClassPage.js'));
const CoachingIELTSPage = lazy(() => import('./pages/CoachingIELTSPage.js'));
const CoachingTOEFLPage = lazy(() => import('./pages/CoachingTOEFLPage.js'));
const CoachingPTEPage = lazy(() => import('./pages/CoachingPTEPage.js'));
const CoachingCELPIPPage = lazy(() => import('./pages/CoachingCELPIPPage.js'));
const CoachingDuolingoPage = lazy(() => import('./pages/CoachingDuolingoPage.js'));
const CoachingInterPreparatoryPage = lazy(() => import('./pages/CoachingInterPreparatoryPage.js'));
const CoachingSATPage = lazy(() => import('./pages/CoachingSATPage.js'));
const CoachingGREPage = lazy(() => import('./pages/CoachingGREPage.js'));
const CoachingGMATPage = lazy(() => import('./pages/CoachingGMATPage.js'));
const CoachingFrenchPage = lazy(() => import('./pages/CoachingFrenchPage.js'));
const CoachingGermanPage = lazy(() => import('./pages/CoachingGermanPage.js'));
const ServiceEducationLoanPage = lazy(() => import('./pages/ServiceEducationLoanPage.js'));
const ServiceForexPage = lazy(() => import('./pages/ServiceForexPage.js'));
const ServiceScholarshipPage = lazy(() => import('./pages/ServiceScholarshipPage.js'));
const ServiceSOPPage = lazy(() => import('./pages/ServiceSOPPage.js'));
const ServiceVisaPage = lazy(() => import('./pages/ServiceVisaPage.js'));
const ServiceAirTicketPage = lazy(() => import('./pages/ServiceAirTicketPage.js'));
const ServiceSimCardPage = lazy(() => import('./pages/ServiceSimCardPage.js'));
const ServiceInsurancePage = lazy(() => import('./pages/ServiceInsurancePage.js'));
const Career = lazy(() => import('./pages/Career.js'));
const ContactUs = lazy(() => import('./pages/ContactUs.js'));
const JobDetails = lazy(() => import('./pages/JobDetails.js'));
const News = lazy(() => import('./pages/News.js'));
const Blogs = lazy(() => import('./pages/Blogs.js'));
const Events = lazy(() => import('./pages/Events.js'));
const EventDetails = lazy(() => import('./pages/EventDetails.js'));
const Webinar = lazy(() => import('./pages/Webinar.js'));
const BlogDetails = lazy(() => import('./pages/BlogDetails.js'));
const ApiKeysPage = lazy(() => import('./pages/settings/ApiKeysPage.js'));
const LeadStagesPage = lazy(() => import('./pages/LeadStagesPage.js'));
const StudentStagesPage = lazy(() => import('./pages/StudentStagesPage.js'));
const LeadWalkin = lazy(() => import('./pages/LeadWalkin.js'));
const LeadMetaForm = lazy(() => import('./pages/LeadMetaForm.js'));
const ApiKeys = lazy(() => import('./pages/masters/ApiKeys.js'));
const AiKeysManagement = lazy(() => import('./pages/api/AiKeys.js'));
const Dashboard = lazy(() => import('./pages/Dashboard.js'));
const MyApplications = lazy(() => import('./pages/MyApplications.js'));
const MyApplicationDetail = lazy(() => import('./pages/MyApplicationDetail.js'));
const MyTasksPage = lazy(() => import('./pages/MyTasksPage.js'));
const TeamChatPage = lazy(() => import('./pages/admin/TeamChatPage.js'));
const VendorWhatsAppPage = lazy(() => import('./pages/admin/VendorWhatsAppPage.js'));
const VendorWhatsAppConnectPage = lazy(() => import('./pages/admin/VendorWhatsAppConnectPage.js'));
const KnowledgeBasePage = lazy(() => import('./pages/KnowledgeBasePage.js'));
const EdugineLocker = lazy(() => import('./pages/EdugineLocker.js'));
const GeneralInformation = lazy(() => import('./pages/profile/GeneralInformation.js'));
const EducationHistory = lazy(() => import('./pages/profile/EducationHistory.js'));
const TestScores = lazy(() => import('./pages/profile/TestScores.js'));
const VisaStudyPermit = lazy(() => import('./pages/profile/VisaStudyPermit.js'));
const CmsPostsPage = lazy(() => import('./pages/masters/CmsPostsPage.js'));
const CommentsModerationPage = lazy(() => import('./pages/masters/CommentsModerationPage.js'));
const SuccessStoriesPage = lazy(() => import('./pages/masters/SuccessStoriesPage.js'));
const EdugenFamilyPage = lazy(() => import('./pages/masters/EdugenFamilyPage.js'));
const StudyAbroadContentPage = lazy(() => import('./pages/masters/StudyAbroadContentPage.js'));
const CareerPage = lazy(() => import('./pages/masters/CareerPage.js'));
const LegalPagesPage = lazy(() => import('./pages/masters/LegalPagesPage.js'));
const ContactPage = lazy(() => import('./pages/masters/ContactPage.js'));
const FooterPage = lazy(() => import('./pages/masters/FooterPage.js'));
const CountriesPage = lazy(() => import('./pages/masters/CountriesPage.js'));
const StatesPage = lazy(() => import('./pages/masters/StatesPage.js'));
const CitiesPage = lazy(() => import('./pages/masters/CitiesPage.js'));
const InstitutionTypesPage = lazy(() => import('./pages/masters/InstitutionTypesPage.js'));
const DocumentTypesPage = lazy(() => import('./pages/masters/DocumentTypesPage.js'));
const InstitutionsPage = lazy(() => import('./pages/masters/InstitutionsPage.js'));
const CompaniesPage = lazy(() => import('./pages/masters/CompaniesPage.js'));
const CampusesPage = lazy(() => import('./pages/masters/CampusesPage.js'));
const StreamsPage = lazy(() => import('./pages/masters/StreamsPage.js'));
const AreasPage = lazy(() => import('./pages/masters/AreasPage.js'));
const LevelsPage = lazy(() => import('./pages/masters/LevelsPage.js'));
const CoursesPage = lazy(() => import('./pages/masters/CoursesPage.js'));
const RepresentativesPage = lazy(() => import('./pages/masters/RepresentativesPage.js'));
const EduGradePage = lazy(() => import('./pages/masters/EduGradePage.js'));
const GenInstPage = lazy(() => import('./pages/rnd/GenInstPage.js'));
const GenCampsPage = lazy(() => import('./pages/rnd/GenCampsPage.js'));
const GenCoursePage = lazy(() => import('./pages/rnd/GenCoursePage.js'));
const GenAddressPage = lazy(() => import('./pages/rnd/GenAddressPage.js'));
const OtpPage = lazy(() => import('./pages/notifications/OtpPage.js'));
const NotificationsPage = lazy(() => import('./pages/notifications/NotificationsPage.js'));
const FollowupsPage = lazy(() => import('./pages/notifications/FollowupsPage.js'));
const TodosPage = lazy(() => import('./pages/notifications/TodosPage.js'));
const WhatsAppLogsPage = lazy(() => import('./pages/notifications/WhatsAppLogsPage.js'));
const WhatsAppTemplatesPage = lazy(() => import('./pages/notifications/WhatsAppTemplatesPage.js'));
const EmailTemplatesPage = lazy(() => import('./pages/notifications/EmailTemplatesPage.js'));
const MailboxAccountsPage = lazy(() => import('./pages/masters/MailboxAccountsPage.js'));
const PaymentMethodsPage = lazy(() => import('./pages/accounts/PaymentMethodsPage.js'));
const ProviderInboxPage = lazy(() => import('./pages/provider/ProviderInboxPage.js'));
const StudentMailboxPage = lazy(() => import('./pages/student/StudentMailboxPage.js'));
const EmailLogsPage = lazy(() => import('./pages/notifications/EmailLogsPage.js'));
const LeadsPage = lazy(() => import('./pages/LeadsPage.js'));
const ApplicationsPage = lazy(() => import('./pages/admin/ApplicationsPage.js'));
const StudentApplicationsPage = lazy(() => import('./pages/admin/StudentApplicationsPage.js'));
const StudentsPage = lazy(() => import('./pages/admin/StudentsPage.js'));
const HelpdeskPage = lazy(() => import('./pages/admin/HelpdeskPage.js'));
const UserManagement = lazy(() => import('./pages/admin/UserManagement.js'));
const RoleManagement = lazy(() => import('./pages/admin/RoleManagement.js'));
const VendorsPage = lazy(() => import('./pages/admin/VendorsPage.js'));
const IntegrationsPage = lazy(() => import('./pages/admin/IntegrationsPage.js'));
const ActivitiesPage = lazy(() => import('./pages/analytics/ActivitiesPage.js'));
const Impersonate = lazy(() => import('./pages/Impersonate.js'));
const UniversityDetail = lazy(() => import('./pages/UniversityDetail.js'));

// Shown while a lazily-loaded route chunk downloads.
const RouteFallback = () => (
  <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-label="Loading">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-[#078b72]" />
  </div>
);

const StudentPlaceholder =({ title }) => (
  <div className="p-4">
    <h1 className="text-2xl font-semibold mb-4">{title}</h1>
    <p>Coming soon...</p>
  </div>
);

// The "fillupthe_form" WhatsApp template's button URL was approved by Meta
// with a typo — a literal "{1}" instead of the "{{1}}" placeholder — so the
// dynamic suffix gets appended AFTER that stray text instead of replacing
// it: the link WhatsApp actually sends is
// ".../%7B1%7Dlead-meta-form/<token>" instead of ".../lead-meta-form/<token>".
// That never matches a real route, so it used to fall through to the
// catch-all and land on the homepage. Fixing the template itself means
// editing it in Meta Business Manager (outside this codebase) and waiting
// for re-approval, so this recovers the real path client-side in the
// meantime: if "lead-meta-form/" shows up anywhere in an otherwise-unmatched
// URL, still send them to the actual form instead of home.
function resolveUnmatchedRoutePath(pathname) {
  const marker = 'lead-meta-form/';
  const index = String(pathname || '').indexOf(marker);
  if (index === -1) return '/';
  return `/${pathname.slice(index)}`;
}

export default function App() {
  const location = useLocation();
  const { isAuthenticated, hasRole, user } = useAuth();

  // Scroll to top on every route change (SPA navigation doesn't do this by
  // default), so clicking a card/link never lands mid-page or at the footer.
  // Skip when a hash is present so in-page anchor links keep working.
  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  // Capture ?utm_source=... (Google/Meta ad links, campaign links) the
  // moment it shows up on any page, so a lead created later in this session
  // — from the popup form or the /register page — is tagged with where it
  // actually came from instead of always landing in a generic "Website" bucket.
  useEffect(() => {
    captureLeadSource();
  }, [location.search]);

  const path = location.pathname;
  const isAuthRoute = path.startsWith('/login') || path.startsWith('/register');
  const isLeadWalkinRoute = path.startsWith('/lead-walkin') || path.startsWith('/lead-meta-form');
  const isDashboardRoute =
    path.startsWith('/dashboard') ||
    path.startsWith('/masters') ||
    path.startsWith('/rnd') ||
    path.startsWith('/settings') ||
    path.startsWith('/admin') ||
    path.startsWith('/notifications') ||
    path.startsWith('/leads') ||
    path.startsWith('/applications') ||
    path.startsWith('/lead-stages') ||
    path.startsWith('/student-stages') ||
    path.startsWith('/programs-schools') ||
    path.startsWith('/analytics') ||
    path.startsWith('/integrations') ||
    path.startsWith('/profile') ||
    path.startsWith('/my-applications') ||
    path.startsWith('/eduginelocker') ||
    path.startsWith('/payments') ||
    path.startsWith('/edugini-solutions') ||
    path.startsWith('/my-tasks') ||
    path.startsWith('/mailbox') ||
    path.startsWith('/team-chat') ||
    path.startsWith('/vendor-whatsapp') ||
    path.startsWith('/knowledge-base') ||
    path.startsWith('/api') ||
    path.startsWith('/accounts/') ||
    path.startsWith('/provider/') ||
    path.startsWith('/coaching/demo-class');

  const isProgramsSchools = path.startsWith('/programs-schools');
  const isHomeRoute = path === '/' || path === '/home';
  const isStudyRoute = path.startsWith('/study-in-');
  const isAboutRoute = path.startsWith('/about-us');
  const isPrivacyPolicyRoute = path.startsWith('/privacy-policy');
  const isDisclaimerRoute = path.startsWith('/disclaimer');
  const isFaqsRoute = path.startsWith('/faqs');
  const isTermsRoute = path.startsWith('/terms-and-conditions');
  const isCareerRoute = path.startsWith('/career');
  const isContactRoute = path.startsWith('/contact-us');
  const isJobDetailsRoute = path.startsWith('/job-details');
  const isNewsRoute = path.startsWith('/news');
  const isBlogsRoute = path.startsWith('/blogs');
  const isEventsRoute = path.startsWith('/events');
  const isCoachingRoute = path.startsWith('/coaching');
  const isServiceRoute = path.startsWith('/services');
  const isEventDetailsRoute = path.startsWith('/event-details');
  const isWebinarRoute = path.startsWith('/webinar');
  const isBlogDetailsRoute = path.startsWith('/blog-details');
  const isCourseDetailsRoute = /^\/courses\/[^/]+/.test(path);
  const isCoursesRoute = path === '/courses';
  const showPublicHelpChat = !isDashboardRoute && !isAuthRoute && !isLeadWalkinRoute;
  const showStudentDashboardHelpChat = isDashboardRoute && isAuthenticated && hasRole('student');
  const shouldShowHelpChat = showPublicHelpChat || showStudentDashboardHelpChat;

  const [sidebarOpen, setSidebarOpen] = useState(true);
  useEffect(() => {
    if (isProgramsSchools) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [isProgramsSchools]);

  // Trigger a resize event when sidebar toggles to update layout-dependent components (like filters)
  useEffect(() => {
    // Immediate trigger
    window.dispatchEvent(new Event('resize'));
    // Delayed trigger to account for any CSS transitions
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
    return () => clearTimeout(timer);
  }, [sidebarOpen]);

  const [sessionId] = useState(() => {
    try {
      const k = 'edugen_session_id';
      const existing = localStorage.getItem(k);
      if (existing) return existing;
      const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(k, id);
      return id;
    } catch (_) {
      return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    }
  });

  const [formOpen, setFormOpen] = useState(false);
  const [leadFirst, setLeadFirst] = useState('');
  const [leadLast, setLeadLast] = useState('');
  const [leadPhone, setLeadPhone] = useState('');
  const [leadProgram, setLeadProgram] = useState('');
  const [leadConsent, setLeadConsent] = useState(false);
  const [leadSubmitting, setLeadSubmitting] = useState(false);
  const [leadError, setLeadError] = useState('');
  const [leadSuccess, setLeadSuccess] = useState(false);

  const [ipInfo, setIpInfo] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Use backend proxy to avoid CORS issues with external IP APIs
        const res = await fetch('/api/common/ip-info');
        const json = await res.json();
        
        if (!cancelled && json.ip) {
          setIpInfo({
            ip: json.ip,
            country: json.country_name || json.country || null,
            state: json.region || json.region_code || null,
            city: json.city || null,
          });
        }
      } catch (err) {
        console.warn('Failed to fetch IP info:', err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const key = `${location.pathname}:${sessionId}`;
    const scheduleMs = ipInfo ? 0 : 1500;
    const send = async () => {
      try {
        try {
          const raw = localStorage.getItem('edugen_last_pv') || '{}';
          const map = JSON.parse(raw);
          const lastTs = map[key] || 0;
          if (Date.now() - lastTs < 2000) return;
          map[key] = Date.now();
          localStorage.setItem('edugen_last_pv', JSON.stringify(map));
        } catch (_) {}
        const email = user?.email || null;
        const userId = user?.id || null;
        await fetch('/api/activities', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            action: 'page_view',
            page: location.pathname,
            email: email,
            user_id: userId,
            meta: {
              session_id: sessionId,
              ip: ipInfo?.ip || null,
              country: ipInfo?.country || null,
              state: ipInfo?.state || null,
              city: ipInfo?.city || null,
            },
          }),
        });
      } catch (_) {}
    };
    const t = setTimeout(() => {
      if (!cancelled) {
        send();
      }
    }, scheduleMs);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [location.pathname, sessionId, ipInfo]);

  // Analytics: Click Tracking
  useEffect(() => {
    const handleClick = async (e) => {
      try {
        const target = e.target;
        // Get useful element details
        const tagName = target.tagName;
        let text = target.innerText || target.value || target.getAttribute('aria-label') || '';
        if (text.length > 50) text = text.slice(0, 50) + '...';
        text = text.replace(/\s+/g, ' ').trim();

        // Handle SVG class names
        const className = (target.className instanceof SVGAnimatedString)
          ? target.className.baseVal
          : (typeof target.className === 'string' ? target.className : '');

        const email = user?.email || null;
        const userId = user?.id || null;

        await fetch('/api/activities', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            action: 'click',
            page: location.pathname,
            email,
            user_id: userId,
            meta: {
              session_id: sessionId,
              tag: tagName,
              text: text,
              class: className,
              x: e.clientX,
              y: e.clientY,
              ip: ipInfo?.ip || null,
              country: ipInfo?.country || null,
              state: ipInfo?.state || null,
              city: ipInfo?.city || null,
            },
          }),
        });
      } catch (_) {}
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [location.pathname, user, sessionId, ipInfo]);

  // Analytics instrumentation: session id, ip geo, time on page, click events
  const [pageStartTs, setPageStartTs] = useState(Date.now());
  useEffect(() => {
    setPageStartTs(Date.now());
  }, [location.pathname]);
  useEffect(() => {
    const handleVisibility = async () => {
      try {
        if (document.visibilityState === 'hidden') {
          const durationMs = Math.max(0, Date.now() - pageStartTs);
          const email = user?.email || null;
          const userId = user?.id || null;
          await fetch('/api/activities', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              action: 'page_leave',
              page: location.pathname,
              email,
              user_id: userId,
              meta: {
                session_id: sessionId,
                duration_ms: durationMs,
                started_at: pageStartTs,
                ended_at: Date.now(),
                ip: ipInfo?.ip || null,
                country: ipInfo?.country || null,
                state: ipInfo?.state || null,
                city: ipInfo?.city || null,
              },
            }),
          });
        }
      } catch (_) {}
    };
    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('beforeunload', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('beforeunload', handleVisibility);
    };
  }, [location.pathname, pageStartTs, user, sessionId, ipInfo]);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  useEffect(() => {
    let lastSent = 0;
    const handler = async (e) => {
      const now = Date.now();
      if (now - lastSent < 300) return; // throttle quick bursts
      lastSent = now;
      try {
        const email = user?.email || null;
        const userId = user?.id || null;
        const target = e.target;
        const text = (target?.innerText || target?.value || '').toString().trim().slice(0, 100);
        const tag = (target?.tagName || '').toLowerCase();
        await fetch('/api/activities', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            action: 'click',
            page: location.pathname,
            email,
            user_id: userId,
            meta: {
              session_id: sessionId,
              tag,
              text,
              class: (target?.className || '').toString().slice(0, 200),
              id: target?.id || null,
              x: e.clientX,
              y: e.clientY,
              ip: ipInfo?.ip || null,
              country: ipInfo?.country || null,
              state: ipInfo?.state || null,
              city: ipInfo?.city || null,
            },
          }),
        });
      } catch (_) {}
    };
    window.addEventListener('click', handler, true);
    return () => window.removeEventListener('click', handler, true);
  }, [location.pathname, user, sessionId, ipInfo]);

  return (
    <div className="relative isolate min-h-screen flex flex-col">
      {(isHomeRoute || isCoachingRoute) ? (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[720px] bg-white"
          style={{
            backgroundImage:
              'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.82) 64%, rgba(255,255,255,1) 100%), linear-gradient(to right, rgb(249 195 224), rgb(210 202 254), rgb(165 223 252))',
          }}
        />
      ) : null}
      {!isDashboardRoute && !isAuthRoute && !isLeadWalkinRoute && <Header />}
      <div className="flex flex-1 items-start min-w-0">
        {isDashboardRoute && isAuthenticated && (
          <Suspense fallback={null}>
            <Sidebar
              collapsed={!sidebarOpen}
              onExpand={() => setSidebarOpen(true)}
              onCollapse={() => setSidebarOpen(false)}
            />
          </Suspense>
        )}
        <div className="flex-1 min-w-0 flex flex-col">
          {isDashboardRoute && isAuthenticated && (
            <Suspense fallback={null}>
              <Topbar />
              <ActionPermissionStyles />
            </Suspense>
          )}
          <main className={`flex-1 min-w-0 ${(isHomeRoute || isStudyRoute || isAboutRoute || isPrivacyPolicyRoute || isDisclaimerRoute || isFaqsRoute || isTermsRoute || isCareerRoute || isContactRoute || isJobDetailsRoute || isNewsRoute || isBlogsRoute || isEventsRoute || isEventDetailsRoute || isWebinarRoute || isBlogDetailsRoute || isCourseDetailsRoute || isCoursesRoute || isCoachingRoute || isServiceRoute) ? 'p-0 overflow-x-hidden max-w-full w-full' : 'p-4'}`}>
            <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route
                path="/"
                element={
                  isAuthenticated
                    ? <Navigate to="/dashboard" replace />
                    : <Home />
                }
              />
              <Route path="/home" element={<Home />} />
              <Route path="/coaching" element={<Coaching />} />
              <Route path="/coaching/ielts" element={<CoachingIELTSPage />} />
              <Route path="/coaching/toefl" element={<CoachingTOEFLPage />} />
              <Route path="/coaching/pte" element={<CoachingPTEPage />} />
              <Route path="/coaching/celpip" element={<CoachingCELPIPPage />} />
              <Route path="/coaching/duolingo" element={<CoachingDuolingoPage />} />
              <Route path="/coaching/inter-preparatory" element={<CoachingInterPreparatoryPage />} />
              <Route path="/coaching/sat" element={<CoachingSATPage />} />
              <Route path="/coaching/gre" element={<CoachingGREPage />} />
              <Route path="/coaching/gmat" element={<CoachingGMATPage />} />
              <Route path="/coaching/french" element={<CoachingFrenchPage />} />
              <Route path="/coaching/german" element={<CoachingGermanPage />} />
              <Route path="/services/education-loan" element={<ServiceEducationLoanPage />} />
              <Route path="/services/forex" element={<ServiceForexPage />} />
              <Route path="/services/scholarship" element={<ServiceScholarshipPage />} />
              <Route path="/services/sop" element={<ServiceSOPPage />} />
              <Route path="/services/visa-service" element={<ServiceVisaPage />} />
              <Route path="/services/air-ticket" element={<ServiceAirTicketPage />} />
              <Route path="/services/sim-card" element={<ServiceSimCardPage />} />
              <Route path="/services/insurance" element={<ServiceInsurancePage />} />
              <Route 
                path="/coaching/demo-class" 
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'staff']}>
                    <CoachingDemoClassPage />
                  </ProtectedRoute>
                } 
              />
              <Route path="/courses" element={<CoursesGatePage />} />
              <Route path="/courses/:id" element={<CourseDetails />} />
              <Route path="/universities/:id" element={<UniversityDetail />} />
              <Route path="/shared-courses/:token" element={<SharedCoursesPage />} />
              {/* Study destination routes */}
              <Route path="/study-in-canada" element={<StudyInCanada />} />
              <Route path="/study-in-uae" element={<StudyInUAE />} />
              <Route path="/study-in-australia" element={<StudyInAustralia />} />
              <Route path="/study-in-australiam" element={<StudyInAustralia />} />
              <Route path="/study-in-new-zealand" element={<StudyInNewZealand />} />
              <Route path="/study-in-usa" element={<StudyInUSA />} />
              <Route path="/study-in-uk" element={<StudyInUK />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/terms-and-conditions" element={<TermsConditions />} />
              <Route path="/career" element={<Career />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/news" element={<News />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/event-details/:id" element={<EventDetails />} />
              <Route path="/webinar" element={<Webinar />} />
              <Route path="/blog-details/:id" element={<BlogDetails />} />
              <Route path="/job-details" element={<JobDetails />} />
              <Route path="/job-details/:id" element={<JobDetails />} />
              <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
              <Route path="/impersonate" element={<Impersonate />} />
              <Route path="/unauthorized" element={
                <div className="p-8 text-center text-red-600 font-bold">
                  <h1>Unauthorized Access</h1>
                  <p>Check Console Logs for details.</p>
                  <button onClick={() => window.location.href = '/dashboard'} className="mt-4 px-4 py-2 bg-blue-500 text-white rounded">
                    Go to Dashboard
                  </button>
                </div>
              } />
              <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} />
              <Route
                path="/dashboard"
                element={
                  // Payment-method providers have no dashboard — login lands
                  // them on /dashboard, so send them to their chat inbox.
                  hasRole('provider') ? <Navigate to="/provider/inbox" replace /> : (
                    <ProtectedRoute requiredRoles={['admin', 'instructor', 'student', 'vendor']}>
                      <Dashboard />
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                path="/provider/inbox"
                element={
                  <ProtectedRoute requiredRoles={['provider']}>
                    <ProviderInboxPage />
                  </ProtectedRoute>
                }
              />

              {/* User Management Routes */}
              <Route
                path="/admin/user-management"
                element={<Navigate to="/admin/user-management/users" replace />}
              />
              <Route
                path="/admin/user-management/users"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'vendor']}>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/user-management/roles"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'vendor']}>
                    <RoleManagement />
                  </ProtectedRoute>
                }
              />

              {/* Student Routes */}
              <Route
                path="/programs-schools"
                element={<CoursesGatePage isDashboard={true} />}
              />
              <Route
                path="/profile/general-information"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <GeneralInformation />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="/profile"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <StudentPlaceholder title="Profile" />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/profile/general-information"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <GeneralInformation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/education-history"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <EducationHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/test-scores"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <TestScores />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile/visa-study-permit"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <VisaStudyPermit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-applications"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <MyApplications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-applications/:applicationId"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <MyApplicationDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/eduginelocker"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <EdugineLocker />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payments"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <StudentPlaceholder title="Payments" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/edugini-solutions"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <StudentPlaceholder title="Edugini Solutions" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-tasks"
                element={
                  <ProtectedRoute requiredRoles={['student', 'admin', 'instructor', 'vendor']}>
                    <MyTasksPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/team-chat"
                element={
                  <ProtectedRoute
                    requiredRoles={['admin', 'instructor', 'vendor']}
                    requiredPermission={{ key: 'team_chat', action: 'view' }}
                  >
                    <TeamChatPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/vendor-whatsapp"
                element={
                  <ProtectedRoute
                    requiredRoles={['admin', 'instructor', 'vendor']}
                    requiredPermission={{ key: 'vendor_whatsapp', action: 'view' }}
                  >
                    <VendorWhatsAppPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/vendor-whatsapp/connect"
                element={
                  <ProtectedRoute
                    requiredRoles={['admin', 'vendor']}
                    requiredPermission={{ key: 'vendor_whatsapp', action: 'view' }}
                  >
                    <VendorWhatsAppConnectPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/knowledge-base"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <KnowledgeBasePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/applications"
                element={
                  <ProtectedRoute
                    requiredRoles={['admin', 'instructor', 'vendor']}
                    requiredPermission={{ key: 'applications_admin', action: 'view' }}
                  >
                    <ApplicationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/applications/student/:studentId"
                element={
                  <ProtectedRoute
                    requiredRoles={['admin', 'instructor', 'vendor']}
                    requiredPermission={{ key: 'applications_admin', action: 'view' }}
                  >
                    <StudentApplicationsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/settings/api-keys"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <ApiKeysPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/lead-stages"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <LeadStagesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/student-stages"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <StudentStagesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/masters/api-keys"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <ApiKeys />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/api/ai-keys"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <AiKeysManagement />
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/masters/countries"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <CountriesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/states"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <StatesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/cities"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <CitiesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/institution-types"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <InstitutionTypesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/document-types"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <DocumentTypesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/institutions"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <InstitutionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/news"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_news', action: 'view' }}>
                    <CmsPostsPage type="news" label="News" defaultTag="News" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/blogs"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_blogs', action: 'view' }}>
                    <CmsPostsPage type="blog" label="Blogs" defaultTag="Blog" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/events"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_events', action: 'view' }}>
                    <CmsPostsPage type="event" label="Events" defaultTag="Event" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/webinars"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_webinars', action: 'view' }}>
                    <CmsPostsPage type="webinar" label="Webinars" defaultTag="Webinar" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/comments"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_comments', action: 'view' }}>
                    <CommentsModerationPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/success-stories"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_success_stories', action: 'view' }}>
                    <SuccessStoriesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/edugen-alumni"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_edugen_alumni', action: 'view' }}>
                    <EdugenFamilyPage type="alumni" label="Edugen Family - Alumni" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/edugen-testimonials"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_edugen_testimonials', action: 'view' }}>
                    <EdugenFamilyPage type="testimonial" label="Edugen Family - Testimonials" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/uk"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_uk', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="uk" countryLabel="UK" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/usa"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_usa', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="usa" countryLabel="USA" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/canada"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_canada', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="canada" countryLabel="Canada" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/australia"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_australia', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="australia" countryLabel="Australia" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/new-zealand"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_new_zealand', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="new-zealand" countryLabel="New Zealand" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/study-abroad/uae"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_study_abroad_uae', action: 'view' }}>
                    <StudyAbroadContentPage countrySlug="uae" countryLabel="UAE" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/career"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_career', action: 'view' }}>
                    <CareerPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/legal-pages"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_legal_pages', action: 'view' }}>
                    <LegalPagesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/contact-us"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_contact_us', action: 'view' }}>
                    <ContactPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/footer"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']} requiredPermission={{ key: 'website_footer', action: 'view' }}>
                    <FooterPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/campuses"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <CampusesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/streams"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <StreamsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/areas"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <AreasPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/levels"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <LevelsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/courses"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <CoursesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/representatives"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <RepresentativesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/companies"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <CompaniesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/edu-grade"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <EduGradePage />
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/rnd/gen_inst"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <GenInstPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rnd/gen_camps"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <GenCampsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rnd/gen_course"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <GenCoursePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rnd/gen_address"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <GenAddressPage />
                  </ProtectedRoute>
                }
              />
              
                <Route path="/admin/users" element={<ProtectedRoute requiredRoles={['admin', 'vendor']}><StudentsPage /></ProtectedRoute>} />
                <Route path="/admin/vendors" element={<ProtectedRoute requiredRoles={['admin']}><VendorsPage /></ProtectedRoute>} />
                <Route path="/admin/integrations" element={<ProtectedRoute requiredRoles={['admin', 'instructor']}><IntegrationsPage /></ProtectedRoute>} />
                <Route path="/leads" element={<ProtectedRoute requiredRoles={['admin', 'instructor', 'vendor']}><LeadsPage /></ProtectedRoute>} />
              <Route
                path="/lead-walkin"
                element={<LeadWalkin />}
              />
              <Route
                path="/lead-meta-form/:token"
                element={<LeadMetaForm />}
              />
              <Route
                path="/lead-meta-form/:token/*"
                element={<LeadMetaForm />}
              />
              <Route
                path="/admin/helpdesk"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'vendor']}>
                    <HelpdeskPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics/activities"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <ActivitiesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/otp"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <OtpPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <NotificationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/followups"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <FollowupsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/todos"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <TodosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/whatsapp"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <WhatsAppLogsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/email"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <EmailLogsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/whatsapp-templates"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <WhatsAppTemplatesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/whatsapp-templates"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <WhatsAppTemplatesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications/email-templates"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <EmailTemplatesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/email-templates"
                element={
                  <ProtectedRoute requiredRoles={['admin', 'instructor']}>
                    <EmailTemplatesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/masters/mailbox-accounts"
                element={
                  <ProtectedRoute requiredRoles={['admin']}>
                    <MailboxAccountsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/accounts/payment-methods"
                element={
                  <ProtectedRoute requiredRoles={['admin']}>
                    <PaymentMethodsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mailbox"
                element={
                  <ProtectedRoute requiredRoles={['student']}>
                    <StudentMailboxPage />
                  </ProtectedRoute>
                }
              />

              {/* Fallback */}
              <Route path="*" element={<Navigate to={resolveUnmatchedRoutePath(location.pathname)} replace />} />
            </Routes>
            </Suspense>
          </main>
          {!isDashboardRoute && !isAuthRoute && !isCoursesRoute && !isLeadWalkinRoute && (
            <>
              <div className={`fixed bottom-24 left-3 right-3 z-[230] sm:bottom-28 sm:left-auto sm:right-6 md:right-8 sm:w-[360px] ${formOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
                <div
                  aria-hidden={!formOpen}
                  className={`w-full transform transition-transform transition-opacity duration-300 ${formOpen ? 'translate-x-0 opacity-100' : 'translate-y-3 opacity-0 pointer-events-none sm:translate-x-[120%] sm:translate-y-0'} rounded-2xl overflow-hidden shadow-xl border border-gray-200 bg-white`}
                >
                  <div className="bg-[#0F4A43] text-white px-4 py-3">
                    <div className="text-sm font-semibold">Planning to Study Abroad</div>
                    <div className="text-sm">Get free 1-on Counselling with our Experts</div>
                  </div>
                  <form
                    className="p-4 space-y-3"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      if (leadSubmitting) return;
                      setLeadSubmitting(true);
                      setLeadError('');
                      setLeadSuccess(false);
                      try {
                        const phoneClean = (leadPhone || '').replace(/\D/g, '');
                        if (!/^\d{10,}$/.test(phoneClean)) {
                          setLeadError('Enter a valid 10 digit mobile number');
                          setLeadSubmitting(false);
                          return;
                        }
                        const payload = {
                          first_name: leadFirst || null,
                          last_name: leadLast || null,
                          phone_number: phoneClean,
                          register_method: 'mobile_otp',
                          program: leadProgram || null,
                          source: getStoredLeadSource() || undefined,
                        };
                        const res = await fetch('/api/leads/verify-and-create-user', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          credentials: 'include',
                          body: JSON.stringify(payload),
                        });
                        const data = await res.json();
                        if (data?.success) {
                          setLeadSuccess(true);
                          setFormOpen(false);
                          setLeadFirst('');
                          setLeadLast('');
                          setLeadPhone('');
                          setLeadProgram('');
                          setLeadConsent(false);
                        } else {
                          setLeadError(data?.message || 'Submission failed');
                        }
                      } catch (_) {
                        setLeadError('Submission failed');
                      } finally {
                        setLeadSubmitting(false);
                      }
                    }}
                  >
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A9 9 0 1118 5a9 9 0 01-12.879 12.804z" /></svg>
                      </span>
                      <input
                        type="text"
                        placeholder="First Name"
                        className="w-full rounded-lg border border-gray-300 bg-gray-100 text-gray-900 placeholder-gray-400 px-3 py-3 pl-9 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        value={leadFirst}
                        onChange={(e) => setLeadFirst(e.target.value)}
                      />
                    </div>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A9 9 0 1118 5a9 9 0 01-12.879 12.804z" /></svg>
                      </span>
                      <input
                        type="text"
                        placeholder="Last Name"
                        className="w-full rounded-lg border border-gray-300 bg-gray-100 text-gray-900 placeholder-gray-400 px-3 py-3 pl-9 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        value={leadLast}
                        onChange={(e) => setLeadLast(e.target.value)}
                      />
                    </div>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" /></svg>
                      </span>
                      <input
                        type="tel"
                        placeholder="10 Digit Mobile Number"
                        className="w-full rounded-lg border border-gray-300 bg-gray-100 text-gray-900 placeholder-gray-400 px-3 py-3 pl-9 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        value={leadPhone}
                        onChange={(e) => setLeadPhone(e.target.value)}
                      />
                    </div>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h10" /></svg>
                      </span>
                      <select
                        className="w-full rounded-lg border border-gray-300 bg-gray-100 text-gray-900 px-3 py-3 pl-9 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        value={leadProgram}
                        onChange={(e) => setLeadProgram(e.target.value)}
                      >
                        <option value="">-- Select Program --</option>
                        <option value="undergraduate">Undergraduate</option>
                        <option value="postgraduate">Postgraduate</option>
                        <option value="diploma">Diploma</option>
                        <option value="language-courses">Language Courses</option>
                      </select>
                    </div>
                    <label className="flex items-start gap-2 text-xs text-gray-700">
                      <input type="checkbox" className="mt-1 h-4 w-4" checked={leadConsent} onChange={(e) => setLeadConsent(e.target.checked)} />
                      <span>I authorize Edugen to contact me even if my number is registered with DND to assist with my enquiry and get regular updates through SMS/Whatsapp.</span>
                    </label>
                    {leadError && <div className="text-xs text-red-600">{leadError}</div>}
                    <button
                      type="submit"
                      disabled={leadSubmitting}
                      className="w-full inline-flex items-center justify-center rounded-full py-3 px-6 text-white bg-[#FF5722] hover:bg-[#E64A19] transition-colors disabled:opacity-60"
                    >
                      Book Free Counselling
                    </button>
                  </form>
                </div>
                <div className={`absolute -top-3 right-2 sm:-right-3 ${formOpen ? '' : 'hidden'}`}>
                  <button
                    type="button"
                    onClick={() => setFormOpen(false)}
                    className="w-8 h-8 rounded-full bg-white border border-gray-300 shadow flex items-center justify-center text-gray-700"
                  >
                    ×
                  </button>
                </div>
              </div>
            </>
          )}
          {shouldShowHelpChat && (
            <Suspense fallback={null}>
              <StudentHelpChat
                onOpenForm={showPublicHelpChat ? () => setFormOpen(true) : undefined}
                callHref="tel:+918013801334"
                whatsappHref="https://wa.me/918013801334"
              />
            </Suspense>
          )}
          {!isDashboardRoute && !isAuthRoute && !isLeadWalkinRoute && <Footer />}
        </div>
      </div>
    </div>
  );
}
